<template>
        <v-container>
            <label style="color: gray" disabled>Additional Warranties</label>
            <v-data-table
                :items="this.items"
                :items-per-page="options.itemsPerPage"
                :headers="headers"
                :footer-props.sync="footerProps"
                :options.sync="options"
                hide-default-footer
                :disabled="this.disabled"
            >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:item="items">
                    <tr>
                        <td style="color: gray">{{ items.item.description }}</td>
                        <td style="color: gray">{{ WarrantyStartDate(items.item) }}</td>
                        <td style="color: gray">{{ WarrantyEndDate(items.item) }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-container>
</template>

<script>
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';

export default {
    props: {
        items: {
            required: true
        }
    },
    data() {
        return {
            options: {
                itemsPerPage: -1,
                page: 1,
                sortBy: ['warrantyStartDate'],
                sortDesc: [true]
            },
            footerProps: {
                itemsPerPageOptions: [10, 50, 100]
            },
            headers: [
                { text: 'Description', value: 'description', sortable: true },
                { text: 'Warranty Start', value: 'warrantyStartDate', sortable: true },
                { text: 'Warranty End', value: 'warrantyEndDate', sortable: false },
            ],
        };
    },
    methods: {
        WarrantyStartDate(item) {
            return this.formatWarrantyDate(item.warrantyStartDate);
        },
        WarrantyEndDate(item) {
            return this.formatWarrantyDate(item.warrantyEndDate);
        },
        formatWarrantyDate(date) {
            if (date) {
                return moment(date).format(DateFormat.DefaultDisplay);
            }
            return 'Unknown';
        }
    }
};
</script>
